import React from 'react';
import { RadioProps, Radio } from '@material-ui/core';
import RadioCheckedIcon from './RadioCheckedIcon';

const NoAnimationRadio = (props: RadioProps) => {
  return <Radio checkedIcon={<RadioCheckedIcon />} {...props} />;
};

export default NoAnimationRadio;
